import React, { useEffect, useState } from "react";
import {
  PieChart,
  Pie,
  ResponsiveContainer,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Area,
  ComposedChart,
} from "recharts";
import { FaHeadphones } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { BsFillPersonFill } from "react-icons/bs";
import { MdSms } from "react-icons/md";
import { BsFillChatLeftTextFill } from "react-icons/bs";
import { toast } from "react-toastify";
import axios from "axios";
import { server } from "../../server";
import { RiContactsBook3Fill } from "react-icons/ri";
import { FaArrowDownUpAcrossLine } from "react-icons/fa6";
import { SiThefinals } from "react-icons/si";
import { BsPatchCheckFill } from "react-icons/bs";
import { RxSpaceBetweenVertically } from "react-icons/rx";
import { FaArrowUpWideShort } from "react-icons/fa6";
import { FaSortAmountDown } from "react-icons/fa";
import { FaBan } from "react-icons/fa";
import { GrTransaction } from "react-icons/gr";
import { FaAngleDoubleUp } from "react-icons/fa";
import { FaAngleDoubleDown } from "react-icons/fa";
import { FaEquals } from "react-icons/fa";

export default function Contact() {
  return (
    <div>
      <div className="mb-6">
        <h2 className="font-bold text-primary underline">
          Telecaller Dashboard
        </h2>
      </div>
      <TelecallerHome />
      <FollowUpType />
      <Outcome />
      <ConversionStage />
      <PriorityLevel />
      <Sentiment />
      <ConversionStatus />
    </div>
  );
}

const TelecallerHome = () => {
  const [assignedCount, setAssignedCount] = useState([]);

  useEffect(() => {
    getConversationsStagesCount();
  }, []);

  const getConversationsStagesCount = async () => {
    try {
      const { data } = await axios.get(
        `${server}/leads/assignedAndFollowUpLeadsCount`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setAssignedCount([
        {
          status: "assigned",
          count: data?.data?.assigned || 0,
          fill: "#825DF5",
        },
        {
          status: "followedUp",
          count: data?.data?.followedUp || 0,
          fill: "#41D2D4",
        },
      ]);
    } catch (e) {
      return toast.error(e?.response?.data?.message || e?.message);
    }
  };

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <div className="grid grid-cols-4 gap-4">
      <div className="p-4 rounded-lg border border-blue-200 shadow bg-blue-200/50">
        <div className="flex gap-4 items-center justify-between">
          <div className="font-semibold">Total Leads</div>
          <div className="text-2xl font-bold text-blue-700">
            {(assignedCount?.find((e) => e?.status === "assigned")?.count ||
              0) +
              (assignedCount?.find((e) => e?.status === "followedUp")?.count ||
                0)}
          </div>
        </div>
      </div>
      <div className="p-4 rounded-lg border border-primaryLight shadow bg-primaryLight/50">
        <div className="flex gap-4 items-center justify-between">
          <div className="font-semibold">Assigned Leads</div>
          <div className="text-2xl font-bold text-primaryDark">
            {assignedCount?.find((e) => e?.status === "assigned")?.count}
          </div>
        </div>
      </div>
      <div className="p-4 rounded-lg border border-secondaryLight shadow bg-secondaryLight/50">
        <div className="flex gap-4 items-center justify-between">
          <div className="font-semibold">Followed Up Leads</div>
          <div className="text-2xl font-bold text-secondaryDark">
            {assignedCount?.find((e) => e?.status === "followedUp")?.count}
          </div>
        </div>
      </div>
      <div className="h-full flex items-end">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart height="100%" margin={{ bottom: -10 }}>
            <Pie
              data={assignedCount}
              cx="50%"
              cy="85%"
              startAngle={180}
              endAngle={0}
              labelLine={false}
              label={renderCustomizedLabel}
              outerRadius={65}
              innerRadius={10}
              fill="#8884d8"
              dataKey="count"
            ></Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="w-full">
          <div className="text-primary font-semibold text-xs">
            Assigned Leads
          </div>
          <div className="text-secondary font-semibold text-xs">
            Assigned Leads
          </div>
        </div>
      </div>
    </div>
  );
};

const FollowUpType = () => {
  const [followUpTypes, setFollowUpTypes] = useState([]);

  useEffect(() => {
    getFollowUpTypesCount();
  }, []);

  const getFollowUpTypesCount = async () => {
    try {
      const { data } = await axios.get(
        `${server}/leads/getFollowUpTypesCount`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      let tempArr = data?.data;
      setFollowUpTypes([
        {
          followUpType: "phone",
          count: tempArr?.find((e) => e?.followUpType === "phone")?.count || 0,
        },
        {
          followUpType: "email",
          count: tempArr?.find((e) => e?.followUpType === "email")?.count || 0,
        },
        {
          followUpType: "in person",
          count:
            tempArr?.find((e) => e?.followUpType === "in person")?.count || 0,
        },
        {
          followUpType: "sms",
          count: tempArr?.find((e) => e?.followUpType === "sms")?.count || 0,
        },
        {
          followUpType: "chat",
          count: tempArr?.find((e) => e?.followUpType === "chat")?.count || 0,
        },
      ]);
    } catch (e) {
      return toast.error(e?.response?.data?.message || e?.message);
    }
  };

  return (
    <div className="mt-6">
      <h1 className="text-gray-500 text-xl font-bold">Follow Up Types</h1>
      <div className="mt-4 grid grid-cols-3 gap-4">
        <div className="grid grid-cols-3 gap-4 col-span-2">
          <div className="p-4 border rounded-lg">
            <div className="flex items-center justify-between">
              <FaHeadphones className="text-secondaryDark" size={30} />
              <p className="text-3xl font-bold text-secondaryDark">
                {followUpTypes?.find((e) => e?.followUpType === "phone")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Phone</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg">
            <div className="flex items-center justify-between">
              <BsFillPersonFill className="text-secondaryDark" size={30} />
              <p className="text-3xl font-bold text-secondaryDark">
                {
                  followUpTypes?.find((e) => e?.followUpType === "in person")
                    ?.count
                }
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>In Person</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg">
            <div className="flex items-center justify-between">
              <MdEmail className="text-secondaryDark" size={30} />
              <p className="text-3xl font-bold text-secondaryDark">
                {followUpTypes?.find((e) => e?.followUpType === "email")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Email</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg">
            <div className="flex items-center justify-between">
              <MdSms className="text-secondaryDark" size={30} />
              <p className="text-3xl font-bold text-secondaryDark">
                {followUpTypes?.find((e) => e?.followUpType === "sms")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>SMS</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg">
            <div className="flex items-center justify-between">
              <BsFillChatLeftTextFill
                className="text-secondaryDark"
                size={30}
              />
              <p className="text-3xl font-bold text-secondaryDark">
                {followUpTypes?.find((e) => e?.followUpType === "chat")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Chat</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>
        </div>
        <div className="h-full">
          <ResponsiveContainer width="100%" height={250}>
            <ComposedChart
              width="100%"
              height="100%"
              data={followUpTypes}
              margin={{ left: -30, top: 20 }}
            >
              <Area
                type="monotone"
                dataKey="count"
                stroke="#41D2D4"
                fill="#abf5f5"
                fillOpacity={0.4}
              />
              <Bar dataKey="count" barSize={20} name="type" fill="#41D2D4" />
              <XAxis
                dataKey="followUpType"
                tick={{ fontSize: 8, angle: -30, dy: 8, dx: -15 }}
                interval={0}
                height={40}
                tickFormatter={(text) => text.toUpperCase()}
              />
              <YAxis dataKey="count" tick={{ fontSize: 10 }} />
              <Tooltip />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

const Outcome = () => {
  const [outcomes, setOutcomes] = useState([]);

  useEffect(() => {
    getOutcomesCount();
  }, []);

  const getOutcomesCount = async () => {
    try {
      const { data } = await axios.get(`${server}/leads/getOutcomesCount`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      let tempArr = data?.data;
      setOutcomes([
        {
          outcome: "positive",
          count: tempArr?.find((e) => e?.outcome === "positive")?.count || 0,
          fill: "#825DF5",
        },
        {
          outcome: "negative",
          count: tempArr?.find((e) => e?.outcome === "negative")?.count || 0,
          fill: "#41D2D4",
        },
        {
          outcome: "neutral",
          count: tempArr?.find((e) => e?.outcome === "neutral")?.count || 0,
          fill: "#94a3b8",
        },
        {
          outcome: "no response",
          count: tempArr?.find((e) => e?.outcome === "no response")?.count || 0,
          fill: "#e11d48",
        },
      ]);
    } catch (e) {
      return toast.error(e?.response?.data?.message || e?.message);
    }
  };

  return (
    <div className="mt-6">
      <h1 className="text-gray-500 text-xl font-bold">Outcomes</h1>
      <div className="mt-4 grid grid-cols-3 gap-4">
        <div className="grid grid-cols-3 gap-4 col-span-2">
          <div className="p-4 border rounded-lg bg-primaryLight/50">
            <div className="flex items-center justify-between">
              <FaAngleDoubleUp className="text-primaryDark" size={30} />
              <p className="text-3xl font-bold text-primaryDark">
                {outcomes?.find((e) => e?.outcome === "positive")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Positive</p>
              <button className="p-1 rounded text-xs text-white bg-primaryDark hover:bg-primary duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg bg-secondaryLight/50">
            <div className="flex items-center justify-between">
              <FaAngleDoubleDown className="text-secondaryDark" size={30} />
              <p className="text-3xl font-bold text-secondaryDark">
                {outcomes?.find((e) => e?.outcome === "negative")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Negative</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg bg-gray-100">
            <div className="flex items-center justify-between">
              <FaEquals className="text-gray-500" size={30} />
              <p className="text-3xl font-bold text-gray-500">
                {outcomes?.find((e) => e?.outcome === "neutral")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Neutral</p>
              <button className="p-1 rounded text-xs text-white bg-gray-500 hover:bg-gray-400 duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg bg-rose-100">
            <div className="flex items-center justify-between">
              <MdSms className="text-rose-600" size={30} />
              <p className="text-3xl font-bold text-rose-600">
                {outcomes?.find((e) => e?.outcome === "no response")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>No Resp.</p>
              <button className="p-1 rounded text-xs text-white bg-rose-600 hover:bg-rose-500 duration-500">
                View More
              </button>
            </div>
          </div>
        </div>
        <div className="h-full">
          <ResponsiveContainer width="100%" height={250}>
            <ComposedChart
              width="100%"
              height="100%"
              data={outcomes}
              margin={{ left: -30, top: 20 }}
            >
              <Area
                type="monotone"
                dataKey="count"
                stroke="#cbd5e1"
                fill="#e2e8f0"
                fillOpacity={0.4}
              />
              <Bar dataKey="count" barSize={20} name="outcome" fill="#825DF5" />
              <XAxis
                dataKey="outcome"
                tick={{ fontSize: 8, angle: -30, dy: 8, dx: -15 }}
                interval={0}
                height={40}
                tickFormatter={(text) => text.toUpperCase()}
              />
              <YAxis dataKey="count" tick={{ fontSize: 10 }} />
              <Tooltip />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

const ConversionStage = () => {
  const [stages, setStages] = useState([]);

  useEffect(() => {
    getConversationsStagesCount();
  }, []);

  const getConversationsStagesCount = async () => {
    try {
      const { data } = await axios.get(
        `${server}/leads/getConversationStagesCount`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      let tempArr = data?.data;
      setStages([
        {
          stage: "lead",
          count: tempArr?.find((e) => e?.stage === "lead")?.count || 0,
          fill: "#41D2D4",
        },
        {
          stage: "interested",
          count: tempArr?.find((e) => e?.stage === "interested")?.count || 0,
          fill: "#41D2D4",
        },
        {
          stage: "negotiation",
          count: tempArr?.find((e) => e?.stage === "negotiation")?.count || 0,
          fill: "#41D2D4",
        },
        {
          stage: "finalizing",
          count: tempArr?.find((e) => e?.stage === "finalizing")?.count || 0,
          fill: "#41D2D4",
        },
        {
          stage: "converted",
          count: tempArr?.find((e) => e?.stage === "converted")?.count || 0,
          fill: "#41D2D4",
        },
      ]);
    } catch (e) {
      return toast.error(e?.response?.data?.message || e?.message);
    }
  };

  return (
    <div className="mt-6">
      <h1 className="text-gray-500 text-xl font-bold">Conversion Stages</h1>
      <div className="mt-4 grid grid-cols-3 gap-4">
        <div className="grid grid-cols-3 gap-4 col-span-2">
          <div className="p-4 border rounded-lg">
            <div className="flex items-center justify-between">
              <RiContactsBook3Fill className="text-secondaryDark" size={30} />
              <p className="text-3xl font-bold text-secondaryDark">
                {stages?.find((e) => e?.stage === "lead")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Lead</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg">
            <div className="flex items-center justify-between">
              <BsFillPersonFill className="text-secondaryDark" size={30} />
              <p className="text-3xl font-bold text-secondaryDark">
                {stages?.find((e) => e?.interested === "Interested")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>In Person</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg">
            <div className="flex items-center justify-between">
              <FaArrowDownUpAcrossLine
                className="text-secondaryDark"
                size={30}
              />
              <p className="text-3xl font-bold text-secondaryDark">
                {stages?.find((e) => e?.stage === "negotiation")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Negotiation</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg">
            <div className="flex items-center justify-between">
              <SiThefinals className="text-secondaryDark" size={30} />
              <p className="text-3xl font-bold text-secondaryDark">
                {stages?.find((e) => e?.stage === "finalizing")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Finalizing</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg">
            <div className="flex items-center justify-between">
              <BsPatchCheckFill className="text-secondaryDark" size={30} />
              <p className="text-3xl font-bold text-secondaryDark">
                {stages?.find((e) => e?.stage === "converted")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Converted</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>
        </div>
        <div className="h-full">
          <ResponsiveContainer width="100%" height={225}>
            <ComposedChart
              width="100%"
              height="100%"
              data={stages}
              margin={{ left: -30, top: 20 }}
            >
              <Area
                type="monotone"
                dataKey="count"
                stroke="#41D2D4"
                fill="#abf5f5"
                fillOpacity={0.4}
              />
              <Bar dataKey="count" barSize={20} fill="#41D2D4" />
              <XAxis
                dataKey="stage"
                tick={{ fontSize: 8, angle: -30, dy: 8, dx: -15 }}
                interval={0}
                height={40}
                tickFormatter={(text) => text.toUpperCase()}
              />
              <YAxis dataKey="count" tick={{ fontSize: 10 }} />
              <Tooltip />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

const PriorityLevel = () => {
  const [Priorities, setPriorities] = useState([]);

  useEffect(() => {
    getPrioritiesCount();
  }, []);

  const getPrioritiesCount = async () => {
    try {
      const { data } = await axios.get(`${server}/leads/getPriorityCount`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      let tempArr = data?.data;
      setPriorities([
        {
          priority: "low",
          count: tempArr?.find((e) => e?.priority === "low")?.count || 0,
          fill: "#94a3b8",
        },
        {
          priority: "medium",
          count: tempArr?.find((e) => e?.priority === "medium")?.count || 0,
          fill: "#41D2D4",
        },
        {
          priority: "high",
          count: tempArr?.find((e) => e?.priority === "high")?.count || 0,
          fill: "#825DF5",
        },
      ]);
    } catch (e) {
      return toast.error(e?.response?.data?.message || e?.message);
    }
  };

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <div className="mt-6">
      <h1 className="text-gray-500 text-xl font-bold">Priority Levels</h1>
      <div className="mt-4 grid grid-cols-3 gap-4">
        <div className="grid grid-cols-3 gap-4 col-span-2">
          <div className="p-4 border rounded-lg bg-gray-100/50">
            <div className="flex items-center justify-between">
              <FaSortAmountDown className="text-gray-500" size={30} />
              <p className="text-3xl font-bold text-gray-500">
                {Priorities?.find((e) => e?.priority === "low")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Low</p>
              <button className="p-1 rounded text-xs text-white bg-gray-500 hover:bg-gray-400 duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg bg-secondaryLight/50">
            <div className="flex items-center justify-between">
              <RxSpaceBetweenVertically
                className="text-secondaryDark"
                size={30}
              />
              <p className="text-3xl font-bold text-secondaryDark">
                {Priorities?.find((e) => e?.priority === "medium")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Medium</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg bg-primaryLight/50">
            <div className="flex items-center justify-between">
              <FaArrowUpWideShort className="text-primaryDark" size={30} />
              <p className="text-3xl font-bold text-primaryDark">
                {Priorities?.find((e) => e?.priority === "high")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>High</p>
              <button className="p-1 rounded text-xs text-white bg-primaryDark hover:bg-primary duration-500">
                View More
              </button>
            </div>
          </div>
        </div>
        <div className="h-full">
          <ResponsiveContainer width="100%">
            <PieChart height="100%" margin={{ bottom: -10 }}>
              <Pie
                data={Priorities}
                cx="50%"
                cy="85%"
                startAngle={180}
                endAngle={0}
                labelLine={false}
                label={renderCustomizedLabel}
                outerRadius={90}
                innerRadius={10}
                fill="#8884d8"
                dataKey="count"
              ></Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

const Sentiment = () => {
  const [sentiments, setSentiments] = useState([]);

  useEffect(() => {
    getSentimentsCount();
  }, []);

  const getSentimentsCount = async () => {
    try {
      const { data } = await axios.get(`${server}/leads/getSentimentCount`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      let tempArr = data?.data;
      setSentiments([
        {
          sentiment: "positive",
          count: tempArr?.find((e) => e?.sentiment === "positive")?.count || 0,
          fill: "#825DF5",
        },
        {
          sentiment: "negative",
          count: tempArr?.find((e) => e?.sentiment === "negative")?.count || 0,
          fill: "#41D2D4",
        },
        {
          sentiment: "neutral",
          count: tempArr?.find((e) => e?.sentiment === "neutral")?.count || 0,
          fill: "#94a3b8",
        },
      ]);
    } catch (e) {
      return toast.error(e?.response?.data?.message || e?.message);
    }
  };

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <div className="mt-6">
      <h1 className="text-gray-500 text-xl font-bold">Sentiments</h1>
      <div className="mt-4 grid grid-cols-3 gap-4">
        <div className="grid grid-cols-3 gap-4 col-span-2 h-fit">
          <div className="p-4 border rounded-lg bg-primaryLight/50">
            <div className="flex items-center justify-between">
              <FaAngleDoubleUp className="text-primaryDark" size={30} />
              <p className="text-3xl font-bold text-primaryDark">
                {sentiments?.find((e) => e?.sentiment === "positive")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Positive</p>
              <button className="p-1 rounded text-xs text-white bg-primaryDark hover:bg-primary duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg bg-secondaryLight/50">
            <div className="flex items-center justify-between">
              <FaAngleDoubleDown className="text-secondaryDark" size={30} />
              <p className="text-3xl font-bold text-secondaryDark">
                {sentiments?.find((e) => e?.sentiment === "negative")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Negative</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg bg-gray-100">
            <div className="flex items-center justify-between">
              <FaEquals className="text-gray-500" size={30} />
              <p className="text-3xl font-bold text-gray-500">
                {sentiments?.find((e) => e?.sentiment === "neutral")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Neutral</p>
              <button className="p-1 rounded text-xs text-white bg-gray-500 hover:bg-gray-400 duration-500">
                View More
              </button>
            </div>
          </div>
        </div>
        <div className="">
          <ResponsiveContainer width="100%">
            <PieChart height="100%" margin={{ bottom: -10 }}>
              <Pie
                data={sentiments}
                cx="50%"
                cy="85%"
                startAngle={180}
                endAngle={0}
                labelLine={false}
                label={renderCustomizedLabel}
                outerRadius={90}
                innerRadius={10}
                fill="#8884d8"
                dataKey="count"
              ></Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

const ConversionStatus = () => {
  const [status, setStatus] = useState([]);

  useEffect(() => {
    getStatusCount();
  }, []);

  const getStatusCount = async () => {
    try {
      const { data } = await axios.get(`${server}/leads/getStatusCount`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      let tempArr = data?.data;
      setStatus([
        {
          status: "new",
          count: tempArr?.find((e) => e?.status === "new")?.count || 0,
          fill: "#41D2D4",
        },
        {
          status: "converted",
          count: tempArr?.find((e) => e?.status === "converted")?.count || 0,
          fill: "#41D2D4",
        },
        {
          status: "on going",
          count: tempArr?.find((e) => e?.status === "on going")?.count || 0,
          fill: "#41D2D4",
        },
        {
          status: "denied",
          count: tempArr?.find((e) => e?.status === "denied")?.count || 0,
          fill: "#41D2D4",
        },
      ]);
    } catch (e) {
      return toast.error(e?.response?.data?.message || e?.message);
    }
  };

  return (
    <div className="mt-6">
      <h1 className="text-gray-500 text-xl font-bold">Conversion Status</h1>
      <div className="mt-4 grid grid-cols-3 gap-4">
        <div className="grid grid-cols-3 gap-4 col-span-2">
          <div className="p-4 border rounded-lg">
            <div className="flex items-center justify-between">
              <RiContactsBook3Fill className="text-secondaryDark" size={30} />
              <p className="text-3xl font-bold text-secondaryDark">
                {status?.find((e) => e?.status === "new")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>New</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg">
            <div className="flex items-center justify-between">
              <BsPatchCheckFill className="text-secondaryDark" size={30} />
              <p className="text-3xl font-bold text-secondaryDark">
                {status?.find((e) => e?.status === "converted")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Converted</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg">
            <div className="flex items-center justify-between">
              <GrTransaction className="text-secondaryDark" size={30} />
              <p className="text-3xl font-bold text-secondaryDark">
                {status?.find((e) => e?.status === "on going")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>On Going</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>

          <div className="p-4 border rounded-lg">
            <div className="flex items-center justify-between">
              <FaBan className="text-secondaryDark" size={30} />
              <p className="text-3xl font-bold text-secondaryDark">
                {status?.find((e) => e?.status === "denied")?.count}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p>Denied</p>
              <button className="p-1 rounded text-xs text-white bg-secondaryDark hover:bg-secondary duration-500">
                View More
              </button>
            </div>
          </div>
        </div>
        <div className="h-full">
          <ResponsiveContainer width="100%" height={230}>
            <ComposedChart
              width="100%"
              height="100%"
              data={status}
              margin={{ left: -30, top: 20 }}
            >
              <Area
                type="monotone"
                dataKey="count"
                stroke="#41D2D4"
                fill="#abf5f5"
                fillOpacity={0.4}
              />
              <Bar dataKey="count" barSize={20} fill="#41D2D4" />
              <XAxis
                dataKey="status"
                tick={{ fontSize: 8, angle: -30, dy: 8, dx: -15 }}
                interval={0}
                height={40}
                tickFormatter={(text) => text.toUpperCase()}
              />
              <YAxis dataKey="count" tick={{ fontSize: 10 }} />
              <Tooltip />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};
